/**
 * Load translations from local JSON (public/locales/{code}.json).
 * Supports en (English) and al (Albanian). Falls back to en for unknown codes.
 * API may send "sq" for Albanian; we map it to "al" to match URL slug and file names.
 */
const SUPPORTED_LOCALES = ['en', 'al'];
const CODE_TO_LOCALE: Record<string, string> = { en: 'en', al: 'al', sq: 'al' };

export const getSupportedLocale = (code: string): string => {
  const normalized = (code || 'en').toLowerCase();
  return CODE_TO_LOCALE[normalized] ?? (SUPPORTED_LOCALES.includes(normalized) ? normalized : 'en');
};

export const loadLocalTranslations = async (code: string): Promise<Record<string, string>> => {
  const locale = getSupportedLocale(code);
  const baseUrl = process.env.PUBLIC_URL || '';
  const url = `${baseUrl}/locales/${locale}.json`;
  try {
    const res = await fetch(url);
    if (!res.ok) {
      if (locale !== 'en') {
        return loadLocalTranslations('en');
      }
      return {};
    }
    const data = await res.json();
    return typeof data === 'object' && data !== null ? data : {};
  } catch {
    if (locale !== 'en') {
      return loadLocalTranslations('en');
    }
    return {};
  }
};
